import { Route, Routes } from "react-router-dom";
import HomePage from "../../pages/home/HomePage";
import VideoConversionPage from "../../pages/video-conversion/VideoConversionPage";
import VideoAnalysisPage from "../../pages/video-analysis/VideoAnalysisPage";
import VideoSegmentationPage from "../../pages/video-segmentation/VideoSegmentationPage";
import ShopPage from "../../pages/shop/ShopPage";
import ShopUsagePage from "../../pages/shop/ShopHistoryPage";
import MyAccountPage from "../../pages/my-account/MyAccountDetailsPage";
import MyAccountEditPage from "../../pages/my-account/MyAccountEditPage";

export default function Routing() {
    return (
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/my-account" element={<MyAccountPage/>} />
            <Route path="/my-account/edit" element={<MyAccountEditPage/>} />
            <Route path="/shop" element={<ShopPage/>} />
            <Route path="/app-usage" element={<ShopUsagePage/>} />
            <Route path="/video-conversion" element={<VideoConversionPage/>} />
            <Route path="/video-analysis" element={<VideoAnalysisPage/>} />
            <Route path="/video-segmentation" element={<VideoSegmentationPage/>} />
        </Routes>
    )
}